import { createZodDto } from 'nestjs-zod/dto';
import { z } from 'zod';
import { dateParser, generalUnitPrice } from '#validation';
import { billingCustomerAddressSchema, overageStorageSchema, platformFeeProductSchema, prepaidMembersSchema, prepaidStorageSchema, teamCacheProductSchema, } from '#web-service-api/billing';
const storageProductSchema = z.object({
    prepaid: prepaidStorageSchema.optional(),
    overage: overageStorageSchema.optional(),
});
const memberProductSchema = z.object({
    prepaid: prepaidMembersSchema.optional(),
    overage: z.object({ price: generalUnitPrice }).optional(),
});
const salesforceContractSchema = z.object({
    id: z.number(),
    startDate: dateParser(),
    type: z.enum(['monthly', 'multi-monthly']),
    intervalCount: z.number(),
    instalmentsCount: z.number().optional(),
    members: memberProductSchema,
    awsStorage: storageProductSchema.optional(),
    customStorage: storageProductSchema.optional(),
    legacyProviders: z
        .object({
        wasabiStorage: storageProductSchema.optional(),
        ibmStorage: storageProductSchema.optional(),
    })
        .optional(),
    nativeLayout: storageProductSchema.optional(),
    teamCache: teamCacheProductSchema.optional(),
    platformFee: platformFeeProductSchema.optional(),
    invoice: z.object({
        daysUntilDue: z.number(),
    }),
    customer: z.object({
        billingEmail: z.email().optional(),
        companyName: z.string().optional(),
        billingAddress: billingCustomerAddressSchema.optional(),
    }),
});
export class SalesforceContractDto extends createZodDto(salesforceContractSchema) {
}
